<template>
  <div id="main">
    <router-view v-wechat-title="title" />
    <loading />
  </div>
</template>
<script>
require('./assets/css/template.css')
import loading from '@/view/Loading'
export default {
  components: { loading },
  data() {
    return {
      title: process.env.VUE_APP_TITLE_TEXT
    }
  }
}
</script>
